import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function PropertyDetail() {
  return (
    <div>
        <Header />
                {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"  style={{
        backgroundImage: "url('assets/img/breadcrumb-bg.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "300px",
      }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Properties Details</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                         Properties Details
                        </li>
                    </ul>
                </div>
            </div>
        </div>
         
        {/* <!-- Propertie Section Start --> */}
        <section class="propertie-section fix section-padding">
            <div class="container">
                <div class="propertie-details-wrapper">
                    <div class="row g-4">
                        <div class="col-lg-8">
                            <div class="propertie-details-wrapper">
                                <div class="details-image">
                                    <img src="assets/img/inner-page/propertie-details/details-01.jpg" alt="img"/>
                                </div>
                                <div class="row g-4 mt-3">
                                    <div class="col-xl-4 col-lg-6 col-md-6">
                                         <div class="details-image">
                                            <img src="assets/img/inner-page/propertie-details/details-02.jpg" alt="img"/>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-6 col-md-6">
                                         <div class="details-image">
                                            <img src="assets/img/inner-page/propertie-details/details-03.jpg" alt="img"/>
                                        </div>
                                    </div>
                                    <div class="col-xl-4 col-lg-6 col-md-6">
                                         <div class="details-image">
                                            <img src="assets/img/inner-page/propertie-details/details-04.jpg" alt="img"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="details-content">
                                    <span class="location"><i class="fa-solid fa-location-dot"></i> 18 Broklyn Street, New York</span>
                                    <h2>Furnished Homes</h2>
                                    <p class="mt-3">
                                        Move-in ready homes fully equipped with stylish furniture, modern appliances, and tasteful décor — perfect for homeowners or tenants who want immediate comfort without the hassle of setting up.
                                    </p>
                                    <div class="list-items">
                                        <h3>Property Overview</h3>
                                        <ul>
                                            <li>
                                               <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                               1860_ sqft
                                            </li>
                                            <li>
                                               <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                                Bedroom_ 6
                                            </li>
                                            <li>
                                                <img src="assets/img/home-1/project/user.png" alt="img"/>
                                               Bath_ 2
                                            </li>
                                            <li>
                                                 <img src="assets/img/home-1/project/full-screen.png" alt="img"/>
                                               Purpose_ For Rent
                                            </li>
                                            <li>
                                               <img src="assets/img/home-1/project/bed.png" alt="img"/>
                                               Parking_ Yes
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="list-items-2">
                                        <h3>Interior Highlights:</h3>
                                        <ul>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>Bedrooms</b>
                                               Beds with premium mattresses, bedside tables, wardrobes, and curtains for privacy  comfort.
                                            </li>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>Elegant Living Area:</b>
                                               Sofa set, coffee table, media console, and smart TV setup – perfect for relaxation  
                                            </li>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>Functional Workspaces :</b>
                                               Some units include study desks, chairs, and ambient lighting for work-from-home.
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="list-items-2">
                                        <h3>Kitchen & Dining Essentials:</h3>
                                        <ul>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>Fully-Stocked Kitchen</b>
                                               Includes toaster, electric kettle, cooking pans, plates, glasses, and cutlery.
                                            </li>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>Dining Area</b>
                                               Matching dining table and chairs suitable for family meals or hosting.
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-4 col-lg-6 col-md-6">
                                            <div class="details-img">
                                                <img src="assets/img/inner-page/service-details/details-02.jpg" alt="img"/>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-6">
                                            <div class="details-img">
                                                <img src="assets/img/inner-page/service-details/details-03.jpg" alt="img"/>
                                            </div>
                                            <div class="details-img style-2">
                                                <img src="assets/img/inner-page/service-details/details-04.jpg" alt="img"/>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-6 col-md-6">
                                            <div class="details-img">
                                                <img src="assets/img/inner-page/service-details/details-05.jpg" alt="img"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list-items-2">
                                        <h3>Lifestyle Perks:</h3>
                                        <ul>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>High-Speed Internet Ready</b>
                                              Routers installed or ISP partnerships available for instant connection.
                                            </li>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>Balconies or Patios</b>
                                              Many units offer outdoor space with chairs or garden views. 
                                            </li>
                                            <li>
                                              <i class="flaticon-right-arrow"></i>
                                               <b>Cleaning & Maintenance</b>
                                              Optional housekeeping and regular maintenance services available.
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="list-items-3">
                                        <h3>Features & amenities</h3>
                                        <div class="list-wrap">
                                            <ul>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                    Airconditioning
                                                </li>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                    Modern Kitchen
                                                </li>
                                            </ul>
                                            <ul>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                    Balcony
                                                </li>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                    Pool
                                                </li>
                                            </ul>
                                            <ul>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                    Landscaping
                                                </li>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                    Indoor Game
                                                </li>
                                            </ul>
                                            <ul>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                    Outdoor Kitchen
                                                </li>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                   Tanis Courts
                                                </li>
                                            </ul>
                                            <ul>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                   Jaguzzi
                                                </li>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                  Fireplace
                                                </li>
                                            </ul>
                                             <ul>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                   Internet
                                                </li>
                                                <li>
                                                    <i class="flaticon-right-arrow"></i>
                                                  Garage
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="floor-plan-items">
                                        <div class="tab-wrap">
                                            <h3>Floor Plan</h3>
                                            <ul class="nav">
                                                <li class="nav-item wow fadeInUp" data-wow-delay=".2s">
                                                    <a href="#Frist" data-bs-toggle="tab" class="nav-link">
                                                        Frist Floor
                                                    </a>
                                                </li>
                                                <li class="nav-item wow fadeInUp" data-wow-delay=".4s">
                                                    <a href="#Second" data-bs-toggle="tab" class="nav-link active">
                                                        Second Floor
                                                    </a>
                                                </li>
                                                <li class="nav-item wow fadeInUp" data-wow-delay=".6s">
                                                    <a href="#Third" data-bs-toggle="tab" class="nav-link">
                                                    Third Floor
                                                    </a>
                                                </li>
                                                <li class="nav-item wow fadeInUp" data-wow-delay=".6s">
                                                    <a href="#Top" data-bs-toggle="tab" class="nav-link">
                                                    Top Garden
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="tab-content">
                                            <div id="Frist" class="tab-pane fade">
                                                <div class="row g-4 align-items-center">
                                                <div class="col-lg-5 col-md-6">
                                                    <div class="thumb">
                                                        <img src="assets/img/inner-page/propertie-details/floor.png" alt="img"/>
                                                    </div>
                                                </div>
                                                <div class="col-lg-7 col-md-6">
                                                    <div class="content">
                                                        <h3>Frist Floor</h3>
                                                        <p class="mt-4">
                                                            Totam rem aperiam, doloremque laudantium, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae dicta sunt explicabo. Adipisci velit, consectetur, dolorem ipsum quia dolor sit amet, sed quia non numquam eius modi tempora incidunt ut labore.
                                                        </p>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            <div id="Second" class="tab-pane fade show active">
                                                 <div class="row g-4 align-items-center">
                                                <div class="col-lg-5 col-md-6">
                                                    <div class="thumb">
                                                        <img src="assets/img/inner-page/propertie-details/floor.png" alt="img"/>
                                                    </div>
                                                </div>
                                                <div class="col-lg-7 col-md-6">
                                                    <div class="content">
                                                        <h3>Frist Floor</h3>
                                                        <p class="mt-4">
                                                            Totam rem aperiam, doloremque laudantium, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae dicta sunt explicabo. Adipisci velit, consectetur, dolorem ipsum quia dolor sit amet, sed quia non numquam eius modi tempora incidunt ut labore.
                                                        </p>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            <div id="Third" class="tab-pane fade">
                                                 <div class="row g-4 align-items-center">
                                                <div class="col-lg-5 col-md-6">
                                                    <div class="thumb">
                                                        <img src="assets/img/inner-page/propertie-details/floor.png" alt="img"/>
                                                    </div>
                                                </div>
                                                <div class="col-lg-7 col-md-6">
                                                    <div class="content">
                                                        <h3>Frist Floor</h3>
                                                        <p class="mt-4">
                                                            Totam rem aperiam, doloremque laudantium, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae dicta sunt explicabo. Adipisci velit, consectetur, dolorem ipsum quia dolor sit amet, sed quia non numquam eius modi tempora incidunt ut labore.
                                                        </p>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            <div id="Top" class="tab-pane fade">
                                                 <div class="row g-4 align-items-center">
                                                <div class="col-lg-5 col-md-6">
                                                    <div class="thumb">
                                                        <img src="assets/img/inner-page/propertie-details/floor.png" alt="img"/>
                                                    </div>
                                                </div>
                                                <div class="col-lg-7 col-md-6">
                                                    <div class="content">
                                                        <h3>Frist Floor</h3>
                                                        <p class="mt-4">
                                                            Totam rem aperiam, doloremque laudantium, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae dicta sunt explicabo. Adipisci velit, consectetur, dolorem ipsum quia dolor sit amet, sed quia non numquam eius modi tempora incidunt ut labore.
                                                        </p>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="video-items">
                                            <h3>Property Video</h3>
                                            <div class="video-image">
                                                <img src="assets/img/inner-page/propertie-details/details-05.jpg" alt="img"/>
                                                <a href="https://www.youtube.com/watch?v=Cn4G2lZ_g2I" class="video-btn video-popup">
                                                    PLAY
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="propertie-details-sidebar">
                               <div class="propertie-sidebar-item mt-0">
                                    <h3>Author Info</h3>
                                    <div class="info-area-item">
                                        <div class="info-items">
                                            <img src="assets/img/inner-page/propertie-details/client.png" alt="img"/>
                                            <div class="info-cont">
                                                <h4>TusHar Raja</h4>
                                                <p>Member since 7 months ago</p>
                                            </div>
                                        </div>
                                         <ul class="info-list">
                                            <li>
                                                <i class="fa-solid fa-phone"></i>
                                                <a href="tel:890923461894">89 (09) 2346 1894</a>
                                            </li>
                                            <li>
                                                <i class="fa-solid fa-envelopes"></i>
                                                <a href="mailto:example@gmail.com">example@gmail.com</a>
                                            </li>
                                            <li>
                                                <i class="fa-solid fa-location-dot"></i>
                                                UK, 1212; 102/B New Elephant Road London
                                            </li>
                                        </ul>
                                        <div class="social-icon d-flex align-items-center">
                                            <span>Social Icon:</span>
                                            <a href="#"><i class="fab fa-facebook-f"></i></a>
                                            <a href="#"><i class="fab fa-twitter"></i></a>
                                            <a href="#"><i class="fab fa-vimeo-v"></i></a>
                                            <a href="#"><i class="fab fa-pinterest-p"></i></a>
                                        </div>
                                        <a href="propertie-details.html" class="link-btn">VIEW PROFILE</a>
                                    </div>
                               </div> 
                               <div class="propertie-sidebar-item">
                                    <h3>Property Contact</h3>
                                    <ul class="contact-list">
                                        <li>
                                            <div class="icon">
                                                <i class="fa-solid fa-location-dot"></i>
                                            </div>
                                            <div class="content">
                                                <span>Address</span>
                                                <h4>23 Broklyn Street, New York</h4>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="fa-solid fa-phone"></i>
                                            </div>
                                            <div class="content">
                                                <span>Phone</span>
                                                <h4><a href="tel:890923461894">89 (09) 2346 1894</a></h4>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="fa-solid fa-envelopes"></i>
                                            </div>
                                            <div class="content">
                                                <span>Email</span>
                                                <h4><a href="mailto:example@gmail.com">example@gmail.com</a></h4>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                               <i class="fa-solid fa-globe"></i>
                                            </div>
                                            <div class="content">
                                                <span>Website</span>
                                                <h4>https://exanple.com/</h4>
                                            </div>
                                        </li>
                                    </ul>
                               </div> 
                               <div class="propertie-sidebar-item">
                                    <h3>Contact Listing Owner</h3>
                                    <form action="#">
                                        <div class="row g-4">
                                            <div class="col-sm-12">
                                                <div class="form-clt">
                                                    <input type="text" name="name" id="name" placeholder="Full Name"/>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="form-clt">
                                                    <input type="text" name="email" id="email" placeholder="Email address"/>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="form-clt">
                                                    <textarea name="message" id="message" placeholder="Message Here*"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <button class="theme-btn" type="submit">
                                                    SUBMIT NOW
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                               </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Footer />
    </div>
  )
}

export default PropertyDetail